import React, { useState, useEffect } from "react";
import { auth, db } from "../firebase"; // Firebase initialization
import { getDoc, doc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import pic from '../assets/download.png'
import logo from '../assets/Rihal_logo-fullcolor-rgb.svg';

const TouristProfilePage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the user is authenticated
    const currentUser = auth.currentUser;
    if (currentUser) {
      // Fetch the user data from Firestore
      const fetchUserData = async () => {
        try {
          const userDoc = await getDoc(doc(db, "users", currentUser.uid));
          if (userDoc.exists()) {
            setUser(userDoc.data()); // Set user data
          } else {
            setError("لا توجد بيانات للمستخدم");
          }
        } catch (err) {
          setError("خطأ في جلب بيانات المستخدم: " + err.message);
        } finally {
          setLoading(false);
        }
      };

      fetchUserData();
    } else {
      // If the user is not authenticated, redirect to login
      navigate("/LoginChoicePage");
    }
  }, [navigate]);

  if (loading) {
    return <div className="text-center text-xl text-gray-600">جاري التحميل...</div>;
  }

  if (error) {
    return <div className="text-center text-xl text-red-500">{error}</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-t from-green-400 via-green-300 to-green-100 flex justify-center items-center py-10">
       <img
              src={logo}
              alt="logo"
              className="bg-transparent blur-sm w-full h-full absolute z-0 p-40"
            />
      <div className="flex items-center backdrop-blur-sm shadow-lg p-20 rounded-2xl">
        
          <div className="space-y-2 flex justify-center items-center flex-col">
            <div className="flex flex-col justify-center items-center space-x-6 z-20">
              <img
                src={user?.photoURL || pic}
                alt="Profile"
                className="w-32 h-32 rounded-full object-cover border-4 border-gray-200 shadow-md"
              />
              <h1 className="text-3xl font-semibold text-gray-800">{user?.name}</h1>
              <p className="text-gray-600 text-lg">{user?.email}</p>
              <p className="text-gray-600 text-lg">{user?.phone}</p>
              <div className="mt-8">
                <h2 className="text-2xl font-semibold text-gray-800">الدور</h2>
                <p className="text-lg text-gray-600">{user?.role}</p>
              </div>

              <div className="mt-8 flex justify-center space-x-4">
                <button
                  onClick={() => auth.signOut()}
                  className="px-6 py-3 bg-red-500 text-white text-lg rounded-full hover:bg-red-600 transition-colors"
                >
                  تسجيل الخروج
                </button>
                <Link
                  to='/'
                  className="px-6 py-3 border-2 border-gray-800 text-gray-800 text-lg rounded-full hover:bg-gray-100 transition-colors"
                >
                  العودة إلى الصفحة الرئيسية
                </Link>
              </div>
          </div>
        </div>


      </div>
    </div>
  );
};

export default TouristProfilePage;
